import { Box } from '@mui/material'
import { IPageBodyLayout } from './types'
import { FC } from 'react'
import classNames from 'classnames'

const PageBodyLayout: FC<IPageBodyLayout> = ({
  className = '',
  dataPart,
  filterPart,
  caseSubheader,
}) => {
  return (
    <>
      {caseSubheader && <Box className='t-page-header'>{caseSubheader}</Box>}
      <Box className={`t-page-body ${className}`}>
        {filterPart && <Box className={'t-page-body-left'}>{filterPart}</Box>}
        <Box
          className={classNames('t-page-body-right', {
            'without-filter': !filterPart,
          })}
        >
          {dataPart}
        </Box>
      </Box>
    </>
  )
}

export default PageBodyLayout
